<template>
  <div class="animated fadeIn">
        <b-card>
            <div slot="header">
              {{ $route.meta.label }}  
              <div class="card-header-actions">
                <button v-if="saveEnabled" class="btn btn-primary mr-1" @click.stop="save()">
                  <i class="fa fa-save"></i> Save
                </button>
                <b-button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
              </div>
            </div>
            <b-row>
                <b-col lg="6">
                    <b-input-group >
                      <b-input-group-prepend><label>Karyawan</label></b-input-group-prepend>
                      <b-form-input v-model="model.crewinfo" readonly :state="!$v.model.crewkey.$error"></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuCrewShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>Jabatan</label></b-input-group-prepend>
                      <b-form-input v-model="model.jabatan" placeholder="Job Title" disabled></b-form-input>
                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>Departemen</label></b-input-group-prepend>
                        <b-form-input v-model="model.departemen" disabled></b-form-input>
                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>Lokasi/Cabang</label></b-input-group-prepend>
                        <b-form-input v-model="model.location" disabled></b-form-input>
                        <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Project</span></b-input-group-prepend>
                        <b-form-input readonly v-model="model.projectname" ></b-form-input>
                    </b-input-group>

                    <b-input-group >
                      <b-input-group-prepend><label>Tgl. Pinjaman</label></b-input-group-prepend>
                      <b-form-input v-model="model.tglpaym" type='date' :state="!$v.model.tglpaym.$error"></b-form-input>
                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>Keterangan Pinjaman</label></b-input-group-prepend>
                        <b-form-textarea v-model="model.uraian" :state="!$v.model.uraian.$error" rows="2" max-rows="4"></b-form-textarea>
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend><label>Jumlah Pinjaman </label></b-input-group-prepend>
                        <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{model.matauang}}</span> </b-input-group-prepend>
                        <my-number v-model="model.jumlah" :precision="2"  :state="!$v.model.jumlah.$error" class="form-control text-right"></my-number>
                        <b-input-group-prepend><span class="ml-2 pt-2 mr-1">BK/KK Pencairan</span></b-input-group-prepend>
                            <b-form-input v-model="model.docrefer"></b-form-input>
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend><label style="width:100px;"> &nbsp; </label></b-input-group-prepend>
                        <b-form-radio-group  v-model="model.tenorCalculated">
                            <b-form-radio  value="1">Nilai Angsuran ditentukan, Tenor Dihitung</b-form-radio>
                            <b-form-radio  value="0">Tenor ditentukan, nilai Angsuran Dihitung</b-form-radio>
                        </b-form-radio-group>                  
                    </b-input-group>
                    <b-input-group v-if="(model.tenorCalculated==1)">
                        <b-input-group-prepend><label>Angsuran per Bulan</label></b-input-group-prepend>
                        <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{model.matauang}}</span> </b-input-group-prepend>
                        <my-number v-model="model.nilai" :precision="2"  class="form-control text-right"></my-number>
                        <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Tgl. Mulai</span></b-input-group-prepend>
                            <b-form-input v-model="model.startdate" type='date'></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="shchedule" >
                            <i class="fa fa-play"></i> Schedule
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                    <b-input-group v-else>
                        <b-input-group-prepend><label>Tenor/Lama Pinjam </label></b-input-group-prepend>
                        <b-form-input v-model="model.tenor" type='number' min="1"></b-form-input>
                        <b-input-group-prepend><span class="input-group-text">bulan</span></b-input-group-prepend>

                        <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Tgl.Mulai Angsuran</span></b-input-group-prepend>
                            <b-form-input v-model="model.startdate" type='date'></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="jadwalAngsuran" >
                            <i class="fa fa-play"></i> Schedule
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                </b-col>
                <b-col lg="6">
                  <b-table
                      class="mb-0"
                      ref="tblDealLines"
                      outlined striped hover small
                      style="font-size:smaller;" 
                      :items="jadwalAngsur.items"
                      :fields="jadwalAngsur.fields"
                      :current-page="jadwalAngsur.page"
                      :per-page="jadwalAngsur.limit"
                        show-empty
                      >
                          <template v-slot:cell(index)="data">
                              {{data.index + 1}}
                          </template>
                          <template v-slot:cell(payrolldate)="data">
                            {{data.item.payrolldate | moment('MMM-YYYY')}}
                          </template>
                          <template v-slot:cell(nilai)="data">
                          {{data.item.nilai|numFormat}}
                          </template>

                          <template v-slot:cell(action)="data">
                              <div class="text-center">
                              <a href="javascript:void(0)" @click="editDealLines(data.item,data.toggleDetails)">
                                  <i class="fa fa-pencil"></i>
                              </a>
                              |
                              <a href="javascript:void(0)" class="text-danger" @click="delDealLines(data.index)">
                                  <i class="fa fa-trash"></i>
                              </a>
                              </div>
                          </template>
                      <template v-slot:row-details="row">
                      <b-card class="row-details-form">
                          <b-row>
                            <b-col lg="6">
                              <b-input-group >
                                <b-input-group-prepend><label>Payroll Date</label></b-input-group-prepend>
                                <b-form-input v-model="dealLinesObj.payrolldate" type='date' :state="!$v.dealLinesObj.payrolldate.$error"></b-form-input>
                              </b-input-group>
                            </b-col>
                            <b-col lg="6">
                              <b-input-group>
                                  <b-input-group-prepend><label>Amount </label></b-input-group-prepend>
                                  <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{model.matauang}}</span> </b-input-group-prepend>
                                  <my-number v-model="dealLinesObj.nilai" :precision="2"  :state="!$v.dealLinesObj.nilai.$error" class="form-control text-right"></my-number>
                              </b-input-group>
                            </b-col>
                          </b-row>
                            <b-row class="justify-content-center">
                                <b-button v-if="saveEnabled" class="btn btn-info mr-1" @click="saveDealLines()">Update</b-button>
                                <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                            </b-row>

                      </b-card>
                      </template>                        
                  </b-table>
                  <b-row class="mt-1">
                            <b-col cols="7">
                              <div style="display: inline;font-size:smaller;">
                                Showing {{(jadwalAngsur.page - 1) * jadwalAngsur.limit + 1}}
                                to <span v-if="((jadwalAngsur.page * jadwalAngsur.limit)>jadwalAngsur.total)">{{jadwalAngsur.total}}</span> <span v-else>{{jadwalAngsur.page * jadwalAngsur.limit}}</span>
                                of {{jadwalAngsur.total}} entries,<span class="ml-2 mr-1">limit per page :</span> 
                                <select  v-model="jadwalAngsur.limit"  style="width:40px;">
                                  <option>12</option>
                                  <option>24</option>
                                  <option>36</option>
                                </select>
                              </div>
                              <b-button size="sm" class="ml-1" @click="addDealLines" >Add Schedule</b-button>  
                            </b-col>
                            <b-col cols="5">            
                              <b-pagination 
                                align="right" size="sm"
                                :total-rows="jadwalAngsur.total"
                                :per-page="jadwalAngsur.limit"
                                v-model="jadwalAngsur.page"
                              ></b-pagination>
                            </b-col>
                  </b-row>
                </b-col>
            </b-row>
            <hr>
            <b-row>
                <b-col lg="6">
                    <b-input-group>
                        <b-input-group-prepend><label style="width:220px;">Salary Item (for Payroll Deduction)</label></b-input-group-prepend>
                        <b-form-input readonly v-model="model.NmKompGaji" :state="!$v.model.IdKompGaji.$error"></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuSalaryitemShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                </b-col>
                <b-col lg="6">
                    <b-input-group>
                        <b-input-group-prepend><label style="width:180px;" class="ml-5">Total Settlement Schedule </label></b-input-group-prepend>
                        <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{model.matauang}}</span> </b-input-group-prepend>
                        <my-number v-model="jadwalAngsur.rekapfix" :precision="2"  disabled class="form-control text-right"></my-number>
                        <button  v-if="saveEnabled" class="btn btn-primary ml-2 mr-1" @click.stop="save()"><i class="fa fa-save"></i> Save</button>
                        <b-button class="btn btn-primary mr-2" @click.stop="close()" > <i class="fa fa-close"></i> Close</b-button>
                    </b-input-group>

                  <b-row class="justify-content-center mb-2">
                  </b-row>
                </b-col>
            </b-row>
        </b-card>
        <b-modal v-model="lkuCrewShow" size="lg" :hide-footer="true" title="List of Employee" :centered="true">
            <lku-crew @click="onSelectLkuCrew"></lku-crew>
        </b-modal>        
      <b-modal v-model="lkuSalaryitemShow" size="lg" :hide-footer="true" title="List of Salary Items" :centered="true" :lazy="true">
          <lku-salaryitem @click="onSelectLkuSalaryitem" ></lku-salaryitem>
      </b-modal>        
  </div>
</template>
<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
</style>
<script>
import moment from 'moment';
import myNumber from "../../components/my-number";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import loan from "../../apis/loan";
import lkuCrew from "../lookup/lkuCrew";
import lkuSalaryitem from '../lookup/lkuSalaryitem';
import toastr from "mini-toastr";
toastr.init();

export default {   
  components:{myNumber,lkuCrew, lkuSalaryitem},
  mixins: [validationMixin],
  validations: {
        model: {
            crewkey: { required },
            tglpaym: {required },
            uraian: { required },
            jumlah: { required },
            IdKompGaji: { required },
        },
        dealLinesObj: {
            payrolldate: { required },
            nilai : { required },
        },
  }, 
  data () {
    return {
        horizontal:true,
        saveEnabled:true,
        model:{crewkey: '',tglpaym:'',tenorCalculated:1,
            jumlah: 0, nilai: 0,startdate:'',IdKompGaji: '',
            uraian: '', docrefer: '', matauang:'IDR' },
        lkuCrewShow:false,
        lkuSalaryitemShow:false,
        currency:[{value:'IDR',text:'IDR'}],
        jadwalAngsur: {
            items: [],
            selected:{},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "payrolldate",
                    label: "Settlement Schedule (Payroll Date)",
                    sortable:true
                },
                {
                    key: "nilai",
                    label: "Amount",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:60px",
                    thClass: "text-center",
                },
            ],
            page: 1,
            limit: 12,
            total: 0,
            rekapfix:0,
        },
        dealLinesObj:{nilai:0, payrolldate:''},
    }
  },
  computed: {
      invalidModel() {
        this.$v.model.$touch();
        return this.$v.model.$invalid;
      },
      invalidDealLines() {
        this.$v.dealLinesObj.$touch();
        return this.$v.dealLinesObj.$invalid;
      },
  //     cicilan() {
  //         return this.model.nilai;
  //     },
  // },
  // watch: {
  //     cicilan: function (newval){
  //         const dibayar = this.jadwalAngsur.items.reduce((a, b) => a + ((b.payrolldtkey) ? b.nilai:0 ), 0);
  //         let sisa = this.model.jumlah-dibayar;
  //         let cicil=0;
  //         while (sisa>0) {
  //           if (sisa<newval) {
  //             cicil=sisa;
  //             sisa=0;
  //           } else {
  //             cicil=newval;
  //             sisa -= newval;
  //           } 
  //           this.jadwalAngsur.items.push({nilai:newval});
  //         }
  //         this.jadwalAngsur.total=this.jadwalAngsur.items.length;
  //         // this.jadwalAngsur.rekapfix = this.jadwalAngsur.items.reduce((a, b) => a + b.nilai, 0);
  //     },
  },
  created: async function(){
      if (this.$route.params.loankey)  {
          toastr.info('Loading Crew Detail, please wait')
          try {
            // const data = await loan.detail(this.$route.params);  
            const data = await loan.detail(this.$route.params) ;
            const row = data[0];
            for (var key in row) {
                this.model[key] = row[key];
            }
          this.model.crewinfo = row.crewname.trim() + ' | ' + row.crewnik.trim();
          this.model.tglpaym= (row.tglpaym) ? moment(row.tglpaym).format('YYYY-MM-DD'): '';
          this.model.startdate= (row.startdate) ? moment(row.startdate).format('YYYY-MM-DD') :'';
          this.model.nilai = row.installment_amount;

             this.jadwalAngsur.items = data[1];
            this.$forceUpdate();

            toastr.clear;
          } catch (error) {
              console.log('error : ', error);
              toastr.error(JSON.stringify(error), "Error Info",10000);                              
          }
      } else {
        this.model.tglpaym=moment().format('YYYY-MM-DD');
      }

  },
  methods:{
    onSelectLkuCrew: async function (_selected) {
        this.model.crewinfo = _selected.crewname.trim() + ' | ' + _selected.crewnik.trim();
            for (var key in _selected) {
                this.model[key] = _selected[key];
            }        
        this.lkuCrewShow=false;
    },
    onSelectLkuSalaryitem: function(_selected){
        this.model.IdKompGaji =_selected.IdKompGaji;
        this.model.NmKompGaji =_selected.NmKompGaji;
        this.model.KdKompGaji =_selected.KdKompGaji;
        this.lkuSalaryitemShow=false;
    },
    jadwalAngsuran() {
          const startdate = moment(this.model.startdate);
          const installment_start=moment(this.model.startdate).startOf("M").add(1,"M");
          this.model.installment_start=installment_start.format('YYYY-MM-DD');;
          const tenor = parseInt(this.model.tenor);
          const date = moment(installment_start).add(tenor, "M");
          this.model.maturityDate = moment(date).format("YYYY-MM-DD");

          this.model.installment_amount=  parseFloat(this.model.jumlah)/tenor;

          this.jadwalAngsur.items=[];
          let totalPokok=0;
          let blnKe=0;
          let angsuranDue='';
          do {
              blnKe+=1;
              const curDate =startdate.startOf("M").add(1,"M");
               angsuranDue = curDate.format("YYYY-MM-DD");
              this.jadwalAngsur.items.push({
                installmentNo:blnKe,
                payrolldate:angsuranDue,
                nilai: this.model.installment_amount
              })             
              totalPokok+=this.model.installment_amount
          } while (totalPokok < pokok) ;
          this.jadwalAngsur.total=this.jadwalAngsur.items.length;
    },

    shchedule: function (){
      if ((this.model.nilai) && (this.model.startdate)) {
         const newval = this.model.nilai;
         let tglCicil = moment(this.model.startdate);
          const dibayar = this.jadwalAngsur.items.reduce((a, b) => a + ((b.payrolldtkey) ? parseFloat(b.nilai):0 ), 0);
          let sisa = parseFloat(this.model.jumlah)-dibayar;
          let cicil=0;
          let installmentNo = this.jadwalAngsur.items.length;
          while (sisa>0) {
            installmentNo += 1;
            if (sisa<newval) {
              cicil=sisa;
              sisa=0;
            } else {
              cicil=newval;
              sisa -= newval;
            } 
            this.jadwalAngsur.items.push({installmentNo, nilai:cicil, payrolldate: tglCicil.format('YYYY-MM-DD'), loanBalance:sisa});
            tglCicil = tglCicil.add(1,'M');
          }
          this.jadwalAngsur.total=this.jadwalAngsur.items.length;
          this.model.tenor = this.jadwalAngsur.total;
          this.model.installment_start= this.jadwalAngsur.items[0].payrolldate;
          this.model.installment_end = this.jadwalAngsur.items[this.jadwalAngsur.total-1].payrolldate;
          this.model.maturityDate = this.model.installment_end;
          this.model.installment_amount = this.model.nilai;
          this.jadwalAngsur.rekapfix = this.jadwalAngsur.items.reduce((a, b) => a + b.nilai, 0);
      }
    },
    closeDealLines: function(){
        const opened= this.jadwalAngsur.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    addDealLines : function () {
        this.closeDealLines();
        const obj={_showDetails:true,IdKompGaji:'', rumus:'', fixincome:'0', NilaiKomp:''};
        this.jadwalAngsur.selected = obj;
        this.dealLinesObj.fixincome=1;
        this.dealLinesObj.NilaiKomp = 0;
        this.dealLinesObj.rumus = '';
        this.dealLinesObj.IdKompGaji = '';
        this.jadwalAngsur.items.push(obj);
        this.jadwalAngsur.total=this.jadwalAngsur.items.length;
    },
    editDealLines : function (obj,callback) {
        if (obj.payrolldtkey) {
            toastr.error('Paid Settlment can not be edit/delete', "Error Info");
        } else {
          this.closeDealLines();
          this.jadwalAngsur.selected = obj;
          for (var key in this.dealLinesObj) {
              this.dealLinesObj[key] = '';
          }
          for (var key in obj) {
              this.dealLinesObj[key] = obj[key];
          }
          callback();
        }
    },
    delDealLines: function (index) {
        if (index > -1) {
          if (this.jadwalAngsur.items[index].payrolldtkey) {
              toastr.error('Paid Settlment can not be edit/delete', "Error Info");
          } else {
            this.jadwalAngsur.items.splice(index, 1);
          }
        }
        this.jadwalAngsur.total=this.jadwalAngsur.items.length;
        this.jadwalAngsur.rekapfix = this.jadwalAngsur.items.reduce((a, b) => a + b.nilai, 0);
        
    },
    saveDealLines: async function (callback) {
        if (this.invalidDealLines) {
            console.log('validation : ', this.$v.dealLinesObj);
            console.log('model obj : ',this.dealLinesObj);
            toastr.error('Please fill the form correctly.', "Error Info");
       } else {
            try {
                    for (var key in this.dealLinesObj) {
                        this.jadwalAngsur.selected[key] = this.dealLinesObj[key];
                    }
                    this.jadwalAngsur.total=this.jadwalAngsur.items.length;
                    this.jadwalAngsur.rekapfix = this.jadwalAngsur.items.reduce((a, b) => a + b.nilai, 0);
                    this.jadwalAngsur.selected._showDetails=false;
                    if (callback) callback();
            } catch (error) {
                console.log('error : ', error);
                if (error.message) {
                    toastr.error(error.message,'Error Info',10000);
                } else {
                    toastr.error(JSON.stringify(error),'Error Info',10000);
                }
            }
        }
    },

    save: async function(){
        // this.model.npwp_name = this.model.npwp_name || this.model.itemname;
        // this.model.npwp_address1 = this.model.npwp_address1 || this.model.item_address1 ;
        // this.model.npwp_address2 = this.model.npwp_address2 || this.model.item_address2;
        // this.model.npwp_city = this.model.npwp_city || this.model.item_city;
        if (this.invalidModel) {
            console.log('validation  : ', this.$v.model);
            console.log('model : ',this.model);
            toastr.error('Please fill the form correctly.', "Error Info");
       } else {
            try {
              const data={};
              for (var key in this.model) {
                  data[key] = this.model[key];
              }     
              data.tglpaym= moment(this.model.tglpaym).format('YYYY-MM-DD');
              data.startdate=moment(this.model.startdate).format('YYYY-MM-DD');
              let lines = this.jadwalAngsur.items.reduce((newArr, item) => {
                  if ((item.payrolldate) && (item.nilai) ) {
                      newArr.push(item);
                  }
                  return newArr;
              }, []);
              this.jadwalAngsur.items=lines;
              this.jadwalAngsur.total=this.jadwalAngsur.items.length;
              this.jadwalAngsur.rekapfix = this.jadwalAngsur.items.reduce((a, b) => a + b.nilai, 0);

              if (this.jadwalAngsur.rekapfix!==this.model.jumlah) {
                  toastr.error('[Settlement Amount] is not balance with [Loan/Bailout Amount]', "Error Info");
              } else {
                    data.lines = lines;
                    console.log('LOANfrm payload: ',data);
                    const hasil = await loan.save(data);
                    toastr.success(`Success, Nomor Pinjaman ${hasil.pinjamanNo}`, "Save EMPLOYEE LOAN",10000);
                    this.close();
              } 
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message, "Error Info",10000);
                } else {
                    toastr.error(JSON.stringify(error), "Error Info",10000);
                }              
            }
        }
    },
    close(){
        router.push({name:'accounting.loan'});
    },    
  }
}
</script>